import Footer, { FooterProps } from '~components/Footer'

type AppFooterProps = Pick<
  FooterProps,
  'variant' | 'containerProps' | 'compactMonochromeLogos'
>
export const AppFooter = (props: AppFooterProps): JSX.Element => {
  return <Footer appLink={window.location.origin} appName="" {...props} />
}
